import Vue from "vue";
import Router from "vue-router";

import store from "@/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // checkLineUser: checkLineUser,
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "",
      redirect: "/login",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      meta: { roleUser: ["Admin"] },
      children: [
        {
          name: "login",
          path: "login",
          component: () => import("@/views/Login"),
          meta: { roleUser: [""] },
          beforeEnter: (to, from, next) => {
            let roleUser = store.state.defaultSystem.user
              ? store.state.defaultSystem.user.role
              : "";
            if (roleUser == "Super Admin") {
              next({ path: "/site" });
            } else if (roleUser == "Root") {
              next({ path: "/users" });
            } else {
              next();
            }
          },
        },
      ],
    },
    {
      path: "",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "dashboard",
          component: () => import("@/views/SuperAdminManager/Dashboard"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "users",
          component: () => import("@/views/SuperAdminManager/User"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "admin-history",
          component: () => import("@/views/SuperAdminManager/AdminHistory"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "customers",
          component: () => import("@/views/SuperAdminManager/Customer"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "missions",
          component: () => import("@/views/SuperAdminManager/MissionList"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "site",
          component: () => import("@/views/SuperAdminManager/Site"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "settings",
          component: () => import("@/views/SuperAdminManager/Settings"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "translate",
          component: () => import("@/views/SuperAdminManager/TranslateList"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          name: "banner-dashboard",
          path: "banner-dashboard/:id",
          component: () =>
            import("@/views/SuperAdminManager/BannerDashboard.vue"),
          meta: { roleUser: ["Super Admin"] },
        },
        {
          path: "ads",
          component: () => import("@/views/SuperAdminManager/Ads"),
          meta: { roleUser: ["Super Admin"] },
        },
        {
          path: "banner-slide",
          component: () => import("@/views/SuperAdminManager/BannerSlide"),
          meta: { roleUser: ["Super Admin"] },
        },
        {
          path: "banner-ads",
          component: () => import("@/views/SuperAdminManager/BannerAds"),
          meta: { roleUser: ["Super Admin"] },
        },
        {
          path: "reward",
          component: () => import("@/views/SuperAdminManager/Reward"),
          meta: { roleUser: ["Super Admin"] },
        },
        {
          name: "rewardreport",
          path: "reward/report/:name/:id",
          component: () => import("@/views/SuperAdminManager/RewardReport"),
          meta: { roleUser: ["Super Admin"] },
        },
        {
          path: "transports",
          component: () => import("@/views/SuperAdminManager/Transport"),
          meta: { roleUser: ["Super Admin"] },
        },
        {
          path: "festival",
          component: () => import("@/views/SuperAdminManager/Festival"),
          meta: { roleUser: ["Super Admin"] },
        },

        {
          path: "sms",
          component: () => import("@/views/SuperAdminManager/SMS"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "otp",
          component: () => import("@/views/SuperAdminManager/OTP"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          name: "reportotp",
          path: "reportotp/:name/:id",
          component: () =>
            import("@/views/SuperAdminManager/ReportLog/ReportOtp"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          name: "reporttransaction",
          path: "reporttransaction/:name/:id",
          component: () =>
            import("@/views/SuperAdminManager/ReportLog/ReportTransaction"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          name: "reporttransactiontotal",
          path: "reporttransactiontotal/:name/:id",
          component: () =>
            import("@/views/SuperAdminManager/ReportLog/ReportSumTransaction"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          name: "reportsms",
          path: "reportsms/:name/:id",
          component: () =>
            import("@/views/SuperAdminManager/ReportLog/ReportSms"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
      ],
    },
    {
      path: "/microsite",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "microsite-list",
          component: () =>
            import("@/views/SuperAdminManager/Microsite/MicrositeList"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "templates-market",
          component: () =>
            import("@/views/SuperAdminManager/Microsite/TemplateMarket"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "templates-market/view/:id",
          component: () =>
            import("@/views/SuperAdminManager/Microsite/TemplateMarketView"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "templates-market/view/:id/login",
          component: () => import("@/components/microsite/template/LoginPage"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "templates-market/view/:id/register",
          component: () =>
            import("@/components/microsite/template/RegisterPage"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "templates-market/view/:id/thankyou",
          component: () =>
            import("@/components/microsite/template/ThankYouPage"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "templates-market/view/:id/announcement",
          component: () =>
            import("@/components/microsite/template/AnnouncementPage"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "templates-market/view/:id/menu",
          component: () => import("@/components/microsite/template/MenuPage"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "templates-market/view/:id/history",
          component: () =>
            import("@/components/microsite/template/HistoryPage"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "templates-market/view/:id/code",
          component: () => import("@/components/microsite/template/CodePage"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "templates-market/view/:id/topSpender",
          component: () =>
            import("@/components/microsite/template/TopSpenderPage"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "templates-market/view/:id/pause",
          component: () => import("@/components/microsite/template/PausePage"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "templates-market/view/:id/end",
          component: () => import("@/components/microsite/template/EndPage"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "templates-market/view/:id/game",
          component: () => import("@/components/microsite/template/GamePage"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
      ],
    },
    {
      path: "/partners",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "partners-list",
          component: () =>
            import("@/views/SuperAdminManager/Partners/PartnersList"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "partners-integrate",
          component: () =>
            import("@/views/SuperAdminManager/Partners/PartnersIntegrate"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
        {
          path: "partners-report",
          component: () =>
            import("@/views/SuperAdminManager/Partners/PartnersReport"),
          meta: { roleUser: ["Root", "Super Admin"] },
        },
      ],
    },
    {
      path: "*",
      name: "error",
      component: () => import("@/views/Error"),
      meta: {
        roleUser: ["Root", "Super Admin", "Admin", "Customer", "unknown"],
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  let role = store.state.defaultSystem.user;
  let roleName = "";
  if (role == null) {
    roleName = "unknown";
  } else {
    roleName = role.role;
  }

  if (!to.meta.roleUser[0]) {
    return next();
  }

  let checkRoleRoutes = to.meta.roleUser
    ? to.meta.roleUser.includes(roleName)
    : next({ name: "error" });

  if (checkRoleRoutes) {
    return next();
  } else {
    return next({ name: "error" });
  }
});

export default router;
